var map = {
	"./action.svg": 85,
	"./address-location.svg": 15,
	"./arrow-to-left.svg": 86,
	"./arrow-to-top.svg": 87,
	"./arrows-back.svg": 16,
	"./back.svg": 88,
	"./checked.svg": 89,
	"./checked2.svg": 90,
	"./circle-cross.svg": 17,
	"./close.svg": 91,
	"./cross.svg": 92,
	"./down.svg": 93,
	"./github.svg": 94,
	"./hook-red.svg": 18,
	"./message.svg": 95,
	"./minus.svg": 19,
	"./more.svg": 96,
	"./more2.svg": 97,
	"./more3.svg": 98,
	"./notice.svg": 99,
	"./plus.svg": 20,
	"./qrcode.svg": 100,
	"./right.svg": 101,
	"./search.svg": 102,
	"./search2.svg": 103,
	"./share.svg": 104,
	"./tick-red.svg": 21,
	"./tick.svg": 105,
	"./top.svg": 106,
	"./trolley.svg": 107,
	"./unchecked.svg": 108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84;